import { useTranslation } from 'react-i18next';
import { useState } from 'react';

interface UpcomingEventsProps {
  onRegister: (tournamentName: string) => void;
}

export default function UpcomingEvents({ onRegister }: UpcomingEventsProps) {
  const { t } = useTranslation();
  const [notifiedEvents, setNotifiedEvents] = useState<number[]>([]);

  const events = [
    {
      id: 1,
      title: "Apex Legends World Championship",
      date: "2024-03-15",
      time: "18:00 EST",
      prize: "$100,000",
      game: "Apex Legends",
      registrationDeadline: "2024-03-10"
    },
    {
      id: 2,
      title: "Fortnite Creative Cup",
      date: "2024-02-28", 
      time: "20:00 EST",
      prize: "$15,000",
      game: "Fortnite",
      registrationDeadline: "2024-02-25"
    },
    {
      id: 3,
      title: "Rocket League Champions League",
      date: "2024-04-05",
      time: "19:00 EST", 
      prize: "$40,000",
      game: "Rocket League",
      registrationDeadline: "2024-04-01"
    },
    {
      id: 4,
      title: "Overwatch 2 Elite Series",
      date: "2024-03-22",
      time: "17:00 EST",
      prize: "$60,000", 
      game: "Overwatch 2",
      registrationDeadline: "2024-03-18"
    }
  ];

  const handleNotifyMe = (eventId: number) => {
    if (notifiedEvents.includes(eventId)) {
      setNotifiedEvents(notifiedEvents.filter(id => id !== eventId));
    } else {
      setNotifiedEvents([...notifiedEvents, eventId]);
    }
  };

  return (
    <section className="py-24 bg-gray-900">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-white mb-4">Upcoming Events</h2>
          <p className="text-gray-400 text-lg">Mark your calendar and prepare for battle</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {events.map((event, index) => (
            <div key={event.id} className="bg-gray-800 border border-gray-700 rounded-xl p-6 hover:border-purple-500 transition-all duration-300">
              <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    <h3 className="text-xl font-bold text-white">{event.title}</h3>
                    <span className="bg-blue-600 text-white px-2 py-1 rounded text-sm">{event.game}</span>
                  </div>
                  
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-4">
                    <div>
                      <p className="text-gray-400 text-sm">Date</p>
                      <p className="text-white font-semibold">{event.date}</p>
                    </div>
                    <div>
                      <p className="text-gray-400 text-sm">Time</p>
                      <p className="text-white font-semibold">{event.time}</p>
                    </div>
                    <div>
                      <p className="text-gray-400 text-sm">Prize Pool</p>
                      <p className="text-green-400 font-bold">{event.prize}</p>
                    </div>
                    <div>
                      <p className="text-gray-400 text-sm">Registration Ends</p>
                      <p className="text-orange-400 font-semibold">{event.registrationDeadline}</p>
                    </div>
                  </div>
                </div>
                
                <div className="flex flex-col sm:flex-row gap-3 md:ml-6">
                  <button 
                    onClick={() => onRegister(event.title)}
                    className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-2 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-user-add-line mr-2"></i>
                    Register
                  </button>
                  <button 
                    onClick={() => handleNotifyMe(event.id)}
                    className={`border px-6 py-2 rounded-lg transition-colors cursor-pointer whitespace-nowrap ${
                      notifiedEvents.includes(event.id)
                        ? 'border-green-500 text-green-400 bg-green-500/10'
                        : 'border-gray-600 text-gray-400 hover:text-white hover:border-purple-500'
                    }`}
                  >
                    <i className={`${notifiedEvents.includes(event.id) ? 'ri-notification-fill' : 'ri-notification-line'} mr-2`}></i>
                    {notifiedEvents.includes(event.id) ? 'Notified' : 'Notify Me'}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
